import { createReducer } from 'src/helpers/reducer';
import actions from './actions';
import type { IRateEngineMutationsState } from './types';

const FAILED_MARKER = 'failed';

const initState: IRateEngineMutationsState = {
  isRenaming: false,
  renameError: null,
  isDeleting: false,
  deleteError: null,
  isArchiving: false,
  archiveError: null,
  isPublishing: false,
  publishError: null,
};

function onRenameRequest(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isRenaming: true, renameError: null };
}

function onRenameSuccess(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isRenaming: false, renameError: null };
}

function onRenameError(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isRenaming: false, renameError: FAILED_MARKER };
}

function onDeleteRequest(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isDeleting: true, deleteError: null };
}

function onDeleteSuccess(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isDeleting: false, deleteError: null };
}

function onDeleteError(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isDeleting: false, deleteError: FAILED_MARKER };
}

function onArchiveRequest(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isArchiving: true, archiveError: null };
}

function onArchiveSuccess(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isArchiving: false, archiveError: null };
}

function onArchiveError(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isArchiving: false, archiveError: FAILED_MARKER };
}

function onPublishRequest(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isPublishing: true, publishError: null };
}

function onPublishSuccess(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isPublishing: false, publishError: null };
}

function onPublishError(state: IRateEngineMutationsState): IRateEngineMutationsState {
  return { ...state, isPublishing: false, publishError: FAILED_MARKER };
}

function onClearStore(): IRateEngineMutationsState {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.RENAME_REQUEST]: onRenameRequest,
  [actions.RENAME_SUCCESS]: onRenameSuccess,
  [actions.RENAME_ERROR]: onRenameError,
  [actions.DELETE_REQUEST]: onDeleteRequest,
  [actions.DELETE_SUCCESS]: onDeleteSuccess,
  [actions.DELETE_ERROR]: onDeleteError,
  [actions.ARCHIVE_REQUEST]: onArchiveRequest,
  [actions.ARCHIVE_SUCCESS]: onArchiveSuccess,
  [actions.ARCHIVE_ERROR]: onArchiveError,
  [actions.PUBLISH_REQUEST]: onPublishRequest,
  [actions.PUBLISH_SUCCESS]: onPublishSuccess,
  [actions.PUBLISH_ERROR]: onPublishError,
  [actions.CLEAR_STORE]: onClearStore,
});
